<!-- Desktop Sidebar -->
<aside
  class="fixed top-16 left-0 bottom-0 bg-white dark:bg-gray-800 border-r border-gray-200 dark:border-gray-700 transition-all duration-300 z-30 hidden lg:block"
  [class.w-64]="!sidebarStore.isCollapsed()"
  [class.w-16]="sidebarStore.isCollapsed()"
>
  <nav class="flex flex-col h-full py-4">
    <!-- Main menu items -->
    <div class="flex-1 space-y-1 px-2">
      @for (item of mainMenuItems(); track item.route) {
        @if (item.disabled) {
          <!-- Disabled menu item -->
          <div
            class="flex items-center px-3 py-2 rounded-md text-gray-400 dark:text-gray-600 cursor-not-allowed"
            [class.justify-center]="sidebarStore.isCollapsed()"
            [pTooltip]="disabledTooltip()"
            tooltipPosition="right"
          >
            <svg
              class="w-5 h-5 flex-shrink-0"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                [attr.d]="getIcon(item.icon)"
              />
            </svg>
            @if (!sidebarStore.isCollapsed()) {
              <span class="ml-3">{{ item.labelKey | translate }}</span>
            }
          </div>
        } @else {
          <!-- Enabled menu item -->
          <a
            [routerLink]="item.route"
            routerLinkActive="bg-primary-50 text-primary-600 dark:bg-primary-900/50 dark:text-primary-400"
            [routerLinkActiveOptions]="{ exact: item.exact ?? false }"
            class="flex items-center px-3 py-2 rounded-md text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700 transition-colors"
            [class.justify-center]="sidebarStore.isCollapsed()"
            [title]="sidebarStore.isCollapsed() ? (item.labelKey | translate) : ''"
          >
            <svg
              class="w-5 h-5 flex-shrink-0"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                [attr.d]="getIcon(item.icon)"
              />
            </svg>
            @if (!sidebarStore.isCollapsed()) {
              <span class="ml-3">{{ item.labelKey | translate }}</span>
            }
          </a>
        }
      }
    </div>

    <!-- Separator -->
    <div class="px-4 my-4">
      <div class="border-t border-gray-200 dark:border-gray-700"></div>
    </div>

    <!-- Bottom menu items -->
    <div class="space-y-1 px-2">
      @for (item of bottomMenuItems; track item.route) {
        <a
          [routerLink]="item.route"
          routerLinkActive="bg-primary-50 text-primary-600 dark:bg-primary-900/50 dark:text-primary-400"
          class="flex items-center px-3 py-2 rounded-md text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700 transition-colors"
          [class.justify-center]="sidebarStore.isCollapsed()"
          [title]="sidebarStore.isCollapsed() ? (item.labelKey | translate) : ''"
        >
          <svg class="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              [attr.d]="getIcon(item.icon)"
            />
          </svg>
          @if (!sidebarStore.isCollapsed()) {
            <span class="ml-3">{{ item.labelKey | translate }}</span>
          }
        </a>
      }
    </div>
  </nav>
</aside>

<!-- Mobile Sidebar -->
<aside
  class="fixed top-16 left-0 bottom-0 w-64 bg-white dark:bg-gray-800 border-r border-gray-200 dark:border-gray-700 z-40 transform transition-transform duration-300 lg:hidden"
  [class.translate-x-0]="sidebarStore.isMobileOpen()"
  [class.-translate-x-full]="!sidebarStore.isMobileOpen()"
>
  <nav class="flex flex-col h-full py-4">
    <!-- Main menu items -->
    <div class="flex-1 space-y-1 px-2">
      @for (item of mainMenuItems(); track item.route) {
        @if (item.disabled) {
          <!-- Disabled menu item -->
          <div
            class="flex items-center px-3 py-2 rounded-md text-gray-400 dark:text-gray-600 cursor-not-allowed"
            [pTooltip]="disabledTooltip()"
            tooltipPosition="right"
          >
            <svg
              class="w-5 h-5 flex-shrink-0"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                [attr.d]="getIcon(item.icon)"
              />
            </svg>
            <span class="ml-3">{{ item.labelKey | translate }}</span>
          </div>
        } @else {
          <!-- Enabled menu item -->
          <a
            [routerLink]="item.route"
            routerLinkActive="bg-primary-50 text-primary-600 dark:bg-primary-900/50 dark:text-primary-400"
            [routerLinkActiveOptions]="{ exact: item.exact ?? false }"
            class="flex items-center px-3 py-2 rounded-md text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700 transition-colors"
            (click)="sidebarStore.closeMobile()"
          >
            <svg
              class="w-5 h-5 flex-shrink-0"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                [attr.d]="getIcon(item.icon)"
              />
            </svg>
            <span class="ml-3">{{ item.labelKey | translate }}</span>
          </a>
        }
      }
    </div>

    <!-- Separator -->
    <div class="px-4 my-4">
      <div class="border-t border-gray-200 dark:border-gray-700"></div>
    </div>

    <!-- Bottom menu items -->
    <div class="space-y-1 px-2">
      @for (item of bottomMenuItems; track item.route) {
        <a
          [routerLink]="item.route"
          routerLinkActive="bg-primary-50 text-primary-600 dark:bg-primary-900/50 dark:text-primary-400"
          class="flex items-center px-3 py-2 rounded-md text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700 transition-colors"
          (click)="sidebarStore.closeMobile()"
        >
          <svg class="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              [attr.d]="getIcon(item.icon)"
            />
          </svg>
          <span class="ml-3">{{ item.labelKey | translate }}</span>
        </a>
      }
    </div>
  </nav>
</aside>
